import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import config from '#/config/environment';

const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: config.apiBaseUrl,
    prepareHeaders: (headers, { endpoint }) => {
      if (endpoint !== 'login') {
        const token = localStorage.getItem('jwt');
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  });

  const result = await baseQuery(args, api, extraOptions);

  if (result.error?.status === 401 && !window.location.pathname.includes('login')) {
    localStorage.removeItem('jwt');
    window.location.href = '/login';
  }

  return result;
};

export const api = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: [
    'administrators',
    'assessments',
    'auth',
    'classes',
    'dashboard',
    'growth-cards',
    'instructors',
    'organizations',
    'reports',
    'score-scales',
    'students',
  ],
  endpoints: () => ({}),
});